<template>
    <div class="top-menu">
        <div class="menu-wrap">
            <img class="logo" src="../assets/logo.png" @click="toPage('/')" />
            <div class="ul">
                <div @click="toPage('/')" class="li" :class="{ active: !checkId }" v-if="categoryList.length > 1">首页</div>
                <template v-if="categoryList.length > 1">
                    <div class="li" v-for="(item, idx) in categoryList" :class="{ active: item.id == checkId }" :key="idx" @click="toPage('/list?id=' + item.id, item)">{{ item.name }}</div>
                </template>
                <!-- <div @click="toPage('/about')" class="li">关于我们</div>  -->
            </div>
            <div class="right-info">
                <div class="rbtn btn-login" @click="toLogin" v-if="userInfo == null">登录</div>
                <div class="rbtn btn-reg" @click="toRegister" v-if="userInfo == null">注册</div>
                <div class="rbtn btn-user" @click="toPersonal" v-if="userInfo != null">个人中心</div>
                <div class="mopen" @click="openMenu" v-if="categoryList.length > 1"></div>
            </div>
        </div>
    </div>
    <transition name="fade">
        <div class="mopen-menu" v-if="menu.open">
            <div class="head-wrap">
                <img class="logo" src="../assets/logo.png" />
                <div class="close" @click="hideMenu"></div>
            </div>
            <div class="mul">
                <div @click="toPage('/')" class="mli" :class="{ active: !checkId }" v-if="categoryList.length > 1">首页</div>
                <template v-if="categoryList.length > 1">
                    <div class="mli" v-for="(item, idx) in categoryList" :class="{ active: item.id == checkId }" :key="idx" @click="toPage('/list?id=' + item.id, item)">{{ item.name }}</div>
                </template>
                <!-- <div @click="toPage('/about')" class="mli">关于我们</div> -->
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    components: {},
    props: ['activeId'],
    data() {
        return {
            menu: {
                open: false
            },
            checkId: 0
        }
    },
    computed: {
        userInfo() {
            return this.$store.state.userInfo
        },
        categoryList() {
            return this.$store.state.categoryList
        },
        env() {
            return this.$store.state.env
        }
    },
    created() {
        if (this.activeId) {
            this.checkId = this.activeId
        }
    },
    methods: {
        openMenu() {
            this.menu.open = true
        },
        hideMenu() {
            this.menu.open = false
        },
        toPage(url, item) {
            this.$router.push(url)
            if (item) {
                this.checkId = item.id
                this.$emit('changeActiveId', item.id)
            }
        },
        toRegister() {
            window.location.href = '/register?back=%2Fai-course'
        },
        toLogin() {
            window.location.href = '/login?back=%2Fai-course'
        },
        toPersonal() {
            window.location.href = '/personal'
        }
    }
}
</script>
<style scoped lang="scss">
$s1024: 1;
$s750: 1;
.top-menu {
    width: 100%;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 10;
    background-color: #fff;
    height: 0.6rem;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
    @media screen and (max-width: 1024px) {
        height: (0.6rem * $s1024);
    }
    @media screen and (max-width: 750px) {
        height: (0.8rem * $s750);
    }
    .menu-wrap {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-content: center;
        align-items: center;
        padding: 0 0.35rem;
        height: 100%;
        @media screen and (max-width: 1024px) {
            padding: 0 (0.35rem * $s1024);
        }
        @media screen and (max-width: 750px) {
            padding: 0 (0.35rem * $s750);
        }
        .logo {
            width: 1.25rem;
            height: 0.32rem;
            cursor: pointer;
            @media screen and (max-width: 1024px) {
                width: (1.25rem * $s1024);
                height: (0.32rem * $s1024);
            }
            @media screen and (max-width: 750px) {
                width: (1.25rem * $s750);
                height: (0.32rem * $s750);
            }
        }
        .ul {
            display: flex;
            flex-direction: row;
            justify-content: center;
            @media screen and (max-width: 750px) {
                display: none;
            }
            .li {
                height: 0.6rem;
                border-bottom: 0.04rem solid transparent;
                font-size: 0.16rem;
                line-height: 0.6rem;
                color: #222;
                margin: 0 0.4rem;
                cursor: pointer;
                @media screen and (max-width: 1024px) {
                    height: (0.6rem * $s1024);
                    border-bottom: (0.04rem * $s1024) solid transparent;
                    font-size: (0.16rem * $s1024);
                    line-height: (0.6rem * $s1024);
                    margin: 0 (0.3rem * $s1024);
                }
                &.active,
                &:hover {
                    border-bottom: 0.04rem solid #e4000c;
                    @media screen and (max-width: 1024px) {
                        border-bottom: (0.04rem * $s1024) solid #e4000c;
                    }
                }
            }
        }
        .right-info {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            .rbtn {
                width: 0.76rem;
                height: 0.3rem;
                border-radius: 0 0.04rem;
                font-size: 0.14rem;
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-content: center;
                align-items: center;
                cursor: pointer;
                @media screen and (max-width: 1024px) {
                    width: (0.76rem * $s1024);
                    height: (0.3rem * $s1024);
                    border-radius: 0 (0.04rem * $s1024);
                    font-size: (0.14rem * $s1024);
                }
                @media screen and (max-width: 750px) {
                    width: (0.76rem * $s750);
                    height: (0.3rem * $s750);
                    border-radius: 0 (0.04rem * $s750);
                    font-size: (0.26rem * $s750);
                }
                &.btn-login {
                    background-color: #d9dde3;
                    color: #6f6e71;
                    margin-left: 0.08rem;
                    @media screen and (max-width: 1024px) {
                        margin-left: (0.08rem * $s1024);
                    }
                    @media screen and (max-width: 750px) {
                        margin-left: (0.08rem * $s750);
                        background-color: transparent;
                        color: #090d15;
                    }
                }
                &.btn-reg {
                    background-color: #eb2234;
                    color: #fff;
                    margin-left: 0.08rem;
                    @media screen and (max-width: 1024px) {
                        margin-left: (0.08rem * $s1024);
                    }
                    @media screen and (max-width: 750px) {
                        margin-left: (0.08rem * $s750);
                        background-color: transparent;
                        color: #090d15;
                    }
                }
                &.btn-user {
                    background: url(../assets/icon_mm.png) no-repeat right center;
                    background-size: 0.12rem 0.16rem;
                    padding-right: 0.2rem;
                    color: #eb2234;
                    margin-left: 0.08rem;
                    font-size: 0.16rem;
                    width: fit-content;
                    @media screen and (max-width: 1024px) {
                        margin-left: (0.08rem * $s1024);
                    }
                    @media screen and (max-width: 750px) {
                        margin-left: (0.08rem * $s750);
                        background-color: transparent;
                        color: #090d15;
                    }
                }
            }
            .mopen {
                width: 0.4rem;
                height: 0.28rem;
                background: url(../assets/icon_mopen.png) no-repeat center center;
                background-size: contain;
                margin-left: 0.4rem;
                display: none;
                cursor: pointer;
                @media screen and (max-width: 750px) {
                    display: block;
                }
            }
        }
    }
}

.mopen-menu {
    display: block;
    width: 100%;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 20;
    background: rgba(0, 0, 0, 0.8);
    backdrop-filter: blur(20px);
    @media screen and (min-width: 750px) {
        display: none;
    }
    .head-wrap {
        height: (0.8rem * $s750);
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-content: center;
        align-items: center;
        padding: 0 (0.35rem * $s750);
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        .logo {
            width: (1.25rem * $s750);
            height: (0.32rem * $s750);
        }
        .close {
            width: (0.32rem * $s750);
            height: (0.32rem * $s750);
            background: url(../assets/mclose.png) no-repeat center center;
            background-size: contain;
            cursor: pointer;
        }
    }
    .mul {
        width: 100%;
        padding: 0.5rem 0;
        .mli {
            height: 1.3rem;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-content: center;
            align-items: center;
            font-size: 0.26rem;
            color: #fff;
        }
    }
}
</style>
